import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getLoginPath, getStoredUser } from '../../auth';
import { apiRequest } from '../../utils/api';

const getInitials = (name) => {
	const words = String(name || 'E')
		.trim()
		.split(/\s+/)
		.filter(Boolean);

	return words.slice(0, 2).map((word) => word.charAt(0)).join('').toUpperCase() || 'E';
};

const JobCard = ({ job }) => {
	const navigate = useNavigate();
	const [isSaved, setIsSaved] = useState(Boolean(job.isSaved));
	const [isSaving, setIsSaving] = useState(false);
	const [saveMessage, setSaveMessage] = useState('');
	const [saveError, setSaveError] = useState('');
	const user = getStoredUser();

	useEffect(() => {
		setIsSaved(Boolean(job.isSaved));
	}, [job.isSaved, job.id]);

	const toggleSavedJob = () => {
		setSaveMessage('');
		setSaveError('');

		if (!user) {
			navigate(getLoginPath(`/jobs`));
			return;
		}

		if (user.role !== 'seeker') {
			setSaveError('Login as a candidate to save jobs.');
			return;
		}

		if (isSaving) return;

		setIsSaving(true);

		apiRequest(`/candidate/saved-jobs/${job.id}`, {
			method: isSaved ? 'DELETE' : 'POST',
		})
			.then(data => {
				if (data?.status === 'success') {
					setIsSaved(!isSaved);
					setSaveMessage(isSaved ? 'Removed' : 'Saved');
				}
				setIsSaving(false);
			})
			.catch(error => {
				setSaveError(error.message || 'Unable to save job.');
				setIsSaving(false);
			});
	};

	return (
		<div className="job-block">
			<div className="inner-box">
				<div className="content">
					<span className="company-logo">
						{job.logo ? (
							<img src={job.logo} alt={job.company} />
						) : (
							<span className="company-logo-initials">{getInitials(job.company)}</span>
						)}
					</span>
					<h4><Link to={`/jobs/${job.id}`}>{job.title}</Link></h4>
					<ul className="job-info">
						<li><span className="icon flaticon-briefcase"></span> {job.company}</li>
						<li><span className="icon flaticon-map-locator"></span> {job.location}</li>
						<li><span className="icon flaticon-clock-3"></span> {job.time}</li>
						<li><span className="icon flaticon-money"></span> {job.salary}</li>
						{job.experience && <li><span className="icon flaticon-user"></span> {job.experience}</li>}
					</ul>
					<ul className="job-other-info">
						{(job.tags ?? []).map((tag) => (
							<li className={tag === 'Urgent' ? 'required' : tag === 'Featured' ? 'time' : 'privacy'} key={tag}>{tag}</li>
						))}
					</ul>
					<button className={`bookmark-btn ${isSaved ? 'active' : ''}`} type="button" onClick={toggleSavedJob} disabled={isSaving} title={isSaved ? 'Remove from saved jobs' : user?.role === 'seeker' ? 'Save job' : 'Login as candidate to save'}>
						<span className={isSaving ? 'fa fa-spinner fa-spin' : 'flaticon-bookmark'}></span>
					</button>
					{(saveMessage || saveError) && (
						<div className={`job-save-feedback ${saveError ? 'error' : ''}`}>
							{saveError || saveMessage}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default JobCard;

